<template>
  <div
    class="submit-tender clearfix"
    style="display: inline-block"
  >
    <button
      id="submit_tender"
      :disabled="disabled"
      type="button"
      :class="className"
      @click="init()"
    >{{ $t('action.submit') }}</button>

    <div
      :id="'chooseApprModal' + id"
      :ref="'chooseApprModal' + id"
      class="reveal choose-approver"
    >
      <div class="modal-container">
        <p class="confirm-header">
          {{ $t('tender.submit.popupTitle') }}?
        </p>
        <div class="clearfix">
          <div class="tender-font float-left clearfix">
            {{ $t('tender.submit.chooseApprover') }}
          </div>
        </div>

        <HKLSelect
          class="submit-hkl-select"
          :value="approverId || undefined"
          :options="approverHklOptions"
          :showSearch="true"
          placeholder=""
          @change="onApproverChange"
        />
        <span
          v-if="apprErrHint"
          class="form-error is-visible appr-error-message"
        >
          {{ apprErrHint }}
        </span>
      </div>

      <div class="row align-right nav_btn">
        <button
          type="button"
          class="btn btn--darkblue"
          aria-label="Close reveal"
          @click="closeApprModal()"
        >{{ $t('action.cancel') }}</button>
        <button
          type="submit"
          class="btn btn--orange"
          @click="submitTender()"
        >{{ $t('action.submit') }}</button>
      </div>
    </div>
    <Modal
      ref="alertModal"
      modalId="alert-modal"
    >
      <div slot="content">
        <pre class="modal-pure-text">{{ $t('tender.submit.submitted') }}</pre>
      </div>
      <div slot="btns">
        <button
          type="button"
          class="btn btn--orange"
          @click="navHome()"
        >{{ $t('hint.okay') }}</button>
      </div>
    </Modal>
  </div>
</template>

<script>
import HKLSelect from '@/controls/Select/HKLSelect.vue'
import { EmailTypes, ActionTypes } from '@/utils/consts'
import { tenderStatus } from '@/utils/locale'
import { mapActions, mapMutations, mapGetters } from 'vuex'
import mutationTypes from '@/store/mutation-types'
import { sendEmail } from '@/api/postman/request'
import { getApprovers } from '@/api/users/request'
import notification from '@/utils/notification'
import navigation from '@/utils/navigation'
import lodash from 'lodash'
import Modal from '@/controls/Modal'

export default {
  name: 'SubmitTender',
  components: {
    HKLSelect,
    Modal,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    className: {
      type: String,
      default: 'btn btn--orange',
    },
    id: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      apprErrHint: '',
      approverId: null,
      options: [],
    }
  },
  computed: {
    ...mapGetters('tenders', {
      currentTender: 'currentTender',
      isAddendum: 'isAddendum',
    }),
    approverHklOptions () {
      return (this.options || []).map((opt) => ({
        name: opt.name,
        value: opt.id,
      }))
    },
  },
  beforeDestroyed () {
    if (this.apprModal) {
      this.apprModal.destroy()
    }
  },
  async mounted () {
    const approvers = await getApprovers()
    this.options = lodash.cloneDeep(approvers)
      .sort((a, b) => a.name.localeCompare(b.name))
  },
  methods: {
    ...mapActions('tenders', ['saveCurrentTender', 'updateTenderStatus', 'refreshTender']),
    ...mapMutations('tenders', {
      updateTenderByPath: mutationTypes.TENDER_UPDATE_PATH_FIELD,
    }),
    async init () {
      if (!this.apprModal) {
        this.apprModal = await new Foundation.Reveal($(`#chooseApprModal${this.id}`), {
          closeOnEsc: false,
          closeOnClick: false,
        })
      }
      this.openApprModal()
    },
    openApprModal () {
      this.apprModal.open()
    },
    openAlertModal () {
      this.$refs.alertModal.open()
    },
    closeAlertModal () {
      this.$refs.alertModal.close()
    },
    closeApprModal () {
      this.apprModal.close()
    },
    onApproverChange (id) {
      this.approverId = id || null
      if (this.apprErrHint) {
        this.apprErrHint = ''
      }
    },
    isValidApprover () {
      return this.approverId && (this.options.some(option => option.id === this.approverId))
    },
    async submitTender () {
      if (!this.isValidApprover()) {
        this.apprErrHint = this.$i18n.t('tender.submit.apprRequired')
        return
      }
      try {
        this.$root.$children[0].$refs.loadingLayer.$emit('startLoading')
        this.updateTenderByPath({
          path: ['general', 'approvedBy'],
          newValue: this.approverId,
        })
        await this.saveCurrentTender({ showNotification: false })
        await this.updateTenderStatus({
          id: this.currentTender.general.id,
          status: tenderStatus.WAPPR,
          action: ActionTypes.tenders.submit,
        })
        await this.refreshTender()

        await sendEmail(EmailTypes.tenders.submitForApproval)

        this.$root.$children[0].$refs.loadingLayer.$emit('stopLoading')
        this.closeApprModal()
        this.openAlertModal()
      } catch (err) {
        notification.handleResponseError(err)
      } finally {
        this.$root.$children[0].$refs.loadingLayer.$emit('stopLoading')
      }
    },

    navHome () {
      this.closeAlertModal()
      navigation.toHome()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~styles/popup';
@import "~styles/stickyBtn";

#submit_tender {
  margin-left: 15px;
}
</style>
